import React, {useState} from "react";
import axios from 'axios';
import {API_URL} from "../../../utils/Common";
import MyLoader from "../../sharecomponents/MyLoader";

const initForm = Object.freeze({
    semana: ''
});

const PlanLabores = (props) => {
    const [loader, updateLoader] = useState(false);
    const [formulario, setFormulario] = useState(initForm);
    const [planes, setPlanes] = useState([]);

    const handlerChange = (e) => {
        setFormulario({
            ...formulario,
            [e.target.name]:e.target.value
        })
    };

    const submit = (e) => {
        e.preventDefault();
        console.log(formulario);
        updateLoader(true);
        axios.get(API_URL + '/getTodosPlanes', {params: {...formulario}})
            .then(r => {
                console.log(r.data);
                setPlanes(r.data.planes);
                updateLoader(false);
            })
            .catch(e => {
                console.log(e);
                updateLoader(false);
            });
    };

    const colorVencimiento = (v) => {
        let color = "border px-4 py-2";
        if (v === 1) {
            color = "border border-green-200 px-4 py-2 bg-green-200";
        } else if (v === 0) {
            color = "border border-red-200 px-4 py-2 bg-red-200";
        }

        return color;
    }

    return (
        <div className="w-full p-3 right-0">
            <div className="bg-white border rounded shadow-xl">
                <div className="border-b rounded-t p-3 bg-orange-900">
                    <h5 className="font-bold uppercase text-white">Labores</h5>
                    {/*<p className="text-white text-sm">Sub titulo</p>*/}
                </div>
                <div className="p-5 rounded-b">
                    {/* ---- CONTENIDO --- */}
                    <form className="mb-3" onSubmit={submit}>
                        <div className="flex flex-wrap -mx-3 mb-6">
                            <div className="w-full md:w-1/6 px-3 mb-6 md:mb-0">
                                <input className="text-sm text-right appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-2 px-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                       name="semana" placeholder="semana(yyww)"
                                       onChange={handlerChange}
                                       type="text"/>
                            </div>
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <button type="submit" className="text-sm bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 rounded shadow">
                                    Procesar
                                </button>
                            </div>
                        </div>
                    </form>
                    {
                        planes.map((p,i) => {
                            return (
                                <table key={i} className="w-full my-3 shadow-lg">
                                    <thead>
                                    <tr className="text-left bg-orange-200 border border-orange-700 text-orange-900">
                                        <th className="border border-orange-900 px-2 py-1">
                                            <b>{ p.flor + ' ' + p.variedad + ' ' + p.color }</b> <br/>
                                            Cantidad Tallos: <b>{ p.cantidadTallos }</b> {'   '}
                                            Semana Cosecha: <b>{ p.semanaCosecha }</b>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td className="border border-orange-900 p-2">
                                            <table>
                                                <thead>
                                                <tr className="text-sm text-white content-center bg-orange-800">
                                                    <th className="border border-orange-800">Labor</th>
                                                    <th className="border border-orange-800">Proceso</th>
                                                    {
                                                        p.labores[0].semanas.map((s,j) => {
                                                            return (
                                                                <th key={j} className="border border-orange-800">{s.semana}</th>
                                                            )
                                                        })
                                                    }
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    p.labores.map((l, k) => {
                                                        return (
                                                            <tr key={k}>
                                                                <td className="border px-4 py-2">{l.labor}</td>
                                                                <td className="border px-4 py-2">{l.proceso}</td>
                                                                {
                                                                    l.semanas.map((s, h) => {
                                                                        return (
                                                                            <td key={h}
                                                                                className={colorVencimiento( s.vencido )}>
                                                                                {s.existe}
                                                                            </td>
                                                                        )
                                                                    })
                                                                }
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            );
                        })
                    }
                    {/* ---- ./CONTENIDO --- */}
                </div>
            </div>
            {loader && <MyLoader/>}
        </div>
    );
}

export default PlanLabores;
